<template>
  <article class="biolink-card position-relative" v-if="info">
    <!-- v-bind:style="{ backgroundImage: 'url(' + info.image + ')' }" -->
    <div class="biolink-card-image" v-if="info.image">
      <img :src="info.image" :alt="info.title" class="img-fluid" />
    </div>
    <div class="biolink-card-content">
      <div class="biolink-card-title-container">
        <h3 class="biolink-card-title m-0">{{ info.title }}</h3>
      </div>
    </div>

    <div class="biolink-card-options d-flex">
      <button
        type="button"
        class="biolink-card-button text-white edit mr-2"
        @click="$emit('edit', info)"
      >
        <i class="ri-pencil-fill"></i>
      </button>

      <button
        type="button"
        class="biolink-card-button text-white delete"
        @click="$emit('delete', index)"
      >
        <i class="ri-delete-bin-line"></i>
      </button>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    info: Object,
    index: Number,
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/biolink-card.styl';
</style>
